import { render } from "./CodeToggleButton.vue?vue&type=template&id=dc5e24a6&scoped=true"
import script from "./CodeToggleButton.vue?vue&type=script&lang=js"
export * from "./CodeToggleButton.vue?vue&type=script&lang=js"

import "./CodeToggleButton.vue?vue&type=style&index=0&id=dc5e24a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dc5e24a6"

export default script